import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { GlobalContext } from "../../context/GlobalContext";
import { RoutesNames } from "../../components/utils/routes";
import { useRedirectLogged } from "../../Hooks/useRedirectLogged";
import HeaderMain from "../../components/header/headerMain";
import IconCheck from "../../components/Icons/IconCheck";

import {
  ContainerCheck,
  ContainerImageBack,
  ContainerMain,
  ContainerPillarDescription,
  ContainerTitle,
  ContainPillars,
  Description,
  LinePillar,
  Pillar,
  Title,
  TitlePillar,
} from "../../styles/PageStyles/Main/styles";

const Main = () => {
  useRedirectLogged();
  const navigate = useNavigate();
  const { rol } = useContext(GlobalContext);

  useEffect(() => {
    if (!rol) {
      navigate(RoutesNames.login);
    }
  }, [rol, navigate]);

  return (
    <ContainerMain>
      <HeaderMain />
      <ContainerImageBack>
        <Title>Pilares</Title>
        <ContainPillars>
          <Pillar>
            <ContainerCheck>
              <IconCheck />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Familia</TitlePillar>
                <LinePillar color="#2DCE89" />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar onClick={() => navigate(rol === "ADMIN" ? RoutesNames.healthForm : RoutesNames.healthFormStandard)}>
            <ContainerCheck>
              <IconCheck color="#1166EE" />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Salud</TitlePillar>
                <LinePillar color="#1166EE" />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar>
            <ContainerCheck>
              <IconCheck color="#7400F9" />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Empleo</TitlePillar>
                <LinePillar color="#7400F9" />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar>
            <ContainerCheck>
              <IconCheck color="#7400F9" />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Guía de servicios</TitlePillar>
                <LinePillar color="#7400F9" style={{ width: "43%" }} />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar>
            <ContainerCheck>
              <IconCheck />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>LGTBIQ+</TitlePillar>
                <LinePillar color="#2DCE89" />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar onClick={() => navigate(rol === "ADMIN" ? RoutesNames.othersForms : RoutesNames.othersFormsStandard)}>
            <ContainerCheck>
              <IconCheck color="#1166EE" />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Legal y documental</TitlePillar>
                <LinePillar color="#1166EE" style={{ width: "40%" }} />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar>
            <ContainerCheck>
              <IconCheck color="#1166EE" />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Financiera</TitlePillar>
                <LinePillar color="#1166EE" />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
          <Pillar>
            <ContainerCheck>
              <IconCheck color="#7400F9" />
            </ContainerCheck>
            <ContainerPillarDescription>
              <ContainerTitle>
                <TitlePillar>Seguridad</TitlePillar>
                <LinePillar color="#7400F9" />
              </ContainerTitle>
              <Description>Mujeres, Hombres, Menores de edad, Tercera edad, Familia, Medio ambiente</Description>
            </ContainerPillarDescription>
          </Pillar>
        </ContainPillars>
      </ContainerImageBack>
    </ContainerMain>
  );
};

export default Main;
